import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CAPIUM_URLS } from '../../../core/config/capium-urls.config';
import { PM_SHELL_APP_LAUNCHER_HOST, type PmShellAppLauncherHost } from './pm-shell-app-launcher-host';

/** Capium app launcher popup (top bar grid button): links to the other Capium products and the account home. */
@Component({
  selector: 'pm-shell-app-launcher',
  standalone: true,
  imports: [],
  templateUrl: './pm-shell-app-launcher.component.html',
  styleUrl: './pm-shell-app-launcher.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PmShellAppLauncherComponent {
  /** The Capium product hosts for this environment. */
  readonly urls = CAPIUM_URLS;

  /** What this section still reads from the workspace (see pm-shell-app-launcher-host.ts). */
  private readonly workspace = inject(PM_SHELL_APP_LAUNCHER_HOST);

  get isAppLauncherOpen() {
    return this.workspace.isAppLauncherOpen;
  }

  get reminders() {
    return this.workspace.reminders;
  }

  stopProp(...args: Parameters<PmShellAppLauncherHost['stopProp']>): ReturnType<PmShellAppLauncherHost['stopProp']> {
    return this.workspace.stopProp(...args);
  }

  goToCapiumAccountHome(): void {
    this.isAppLauncherOpen.set(false);
    window.location.assign(`${this.urls.account}/home`);
  }

  goToExternalUrl(url: string): void {
    this.isAppLauncherOpen.set(false);
    window.location.assign(url);
  }
}
